import React from 'react'

const D2DIcon = ({ fill, width, height }) => (
  <svg
    width={width || '28'}
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.664062 26.7634V23.9399H3.33073V3.94222C3.33073 3.25893 3.79206 2.67446 4.4254 2.55305L17.0547 0.121988C17.4894 0.0372824 17.9054 0.343635 17.9841 0.803871C17.9934 0.853282 17.9974 0.902694 17.9974 0.95493V2.76199L23.3307 2.7634C24.0667 2.7634 24.6641 3.39587 24.6641 4.17516V23.9399H27.3307V26.7634H21.9974V5.58693H17.9974V26.7634H0.664062ZM13.9974 12.6458H11.3307V15.4693H13.9974V12.6458Z"
      fill={fill || '#004360'}
    />
  </svg>
)

export default D2DIcon
